module.exports = __webpack_public_path__ + "img/touxiang.03fa15a1.jpg";